import React from 'react';
import {Box, Button, Drawer, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import logo from '../../icons/logo.svg';
import {Hostage} from '../types';
import { decode } from '../../utils/Utils';

type JoinedHostageDrawerProps = {
  open: boolean;
  onClose: () => void;
  hostage: Hostage;
};

const JoinedHostageDrawer: React.FC<JoinedHostageDrawerProps> = ({open, onClose, hostage}) => {
  const {t, i18n} = useTranslation();

  return (
      <Drawer
          anchor="bottom"
          open={open}
          onClose={onClose}
          PaperProps={{style: {borderRadius: '10px 10px 0 0'}}}
      >
        <Box sx={{padding: '8px, 16px, 24px, 16px', margin: '16px', textAlign: 'center'}}>
          <Box
              sx={{

                backgroundColor: '#ccc',
                borderRadius: 2,
                margin: '10px auto',
                cursor: 'pointer'
              }}
              onClick={onClose}
          />
          <Box component="img" src={logo} alt="App Logo" sx={{width: 60, margin: '20px auto'}}/>
          <Typography variant="h6" sx={{fontSize: "18px", fontWeight: 'bold'}}>{decode(t('joinedHostage.title', {name: hostage[i18n.language as "en" | "he"].first_name}))}</Typography>
          <Typography variant="body2" sx={{margin: '10px 0',  fontSize: "14px"}}>
            {decode(t('joinedHostage.subtitle', {name: hostage[i18n.language as "en" | "he"].first_name}))}
          </Typography>
          <Button variant="contained"
                  color="primary"
                  sx={{height: '50px', margin: '20px 0 14px 0', width: '90%', textAlign: 'center'}}
                  onClick={onClose}>
            {t('joinedHostage.gotIt')}
          </Button>
        </Box>
      </Drawer>
  );
};

export default JoinedHostageDrawer;